import { Component, OnInit, Input, Output, EventEmitter, HostListener,
  ElementRef } from '@angular/core';
import { SearchListModel } from './luci-search.model';

@Component({
  selector: 'luci-search',
  templateUrl: './luci-search.component.html',
  styleUrls: ['./luci-search.component.scss']
})
export class LuciSearchComponent implements OnInit {

  @Input() searchUrl = '';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() isAutoSuggestion = false;
  @Input() isClose = false;
  @Input() list: SearchListModel[] = [];
  @Input() icon = '';
  @Input() recentlyTypeLabel = 'Recently Typed';
  @Input() searchQuery = '';
  @Output() searchQueryChange = new EventEmitter<any>();
  @Output() oniconclick = new EventEmitter();
  @Output() updateFilter = new EventEmitter<any>();
  @Output() recentSelectedCallback = new EventEmitter<any>();
  @Input() validation: boolean;
  @Input() numberOnly: boolean;
  @Input() maxValue: number;
  @Input() minValue: number;
  @Input() isSearchTextOnly = false;
  @Input() isRecentSearchEnabled = false;
  @Input() recentSearchList: SearchListModel[] = [];
  @Input() classList = '';
  showRecentSearchList = false;
  @Output() isFocusCallBack = new EventEmitter();

  selectedItem: any = {};
  error: boolean;

  constructor(private el: ElementRef) { }

  ngOnInit() { }

  onKeydown(event) {
    if (this.searchQuery && this.icon !== 'filter' && !this.error) {
      if (event.key === 'Enter') {
        this.openSearch();
      }
    }
  }

  recentSearch() {
    if (this.searchQuery === '') {
      this.showRecentSearchList = true;
    }
    this.isFocusCallBack.emit();
  }

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.showRecentSearchList = false;
    }
  }

  openSearch() {
    if (this.searchUrl) {
      const searchUrl = this.searchUrl + this.searchQuery;
      window.open(searchUrl, '_blank');
    } else {
      this.oniconclick.emit({});
    }
  }

  selectListItem(item) {
    this.selectedItem = item;
    this.searchQuery = item.query;
    this.oniconclick.emit(this.searchQuery);
    this.list = [];
    this.showRecentSearchList = false;
  }

  recentSelectedItem(item) {
    if (item) {
      this.selectedItem = item;
      this.searchQuery = item.query;
      this.recentSelectedCallback.emit(this.searchQuery);
      this.showRecentSearchList = false;
    }
  }

  updateListItem(query) {
    if (this.isRecentSearchEnabled) {
      if (query === '') {
        this.showRecentSearchList = true;
      } else {
        this.showRecentSearchList = false;
      }
    }

    this.searchQuery = query;
    if (this.isAutoSuggestion && this.icon !== 'filter') {
      this.selectedItem = {};
    }
    this.updateFilter.emit(this.searchQuery);
    this.searchQueryChange.emit(this.searchQuery);
    if (this.validation) {
      this.validate();
    }

  }

  clearSearch() {
    this.searchQuery = '';
    this.updateFilter.emit(this.searchQuery);
    this.searchQueryChange.emit(this.searchQuery);
  }

  validate() {
    this.error = false;
    const numberRegex = /^(\s*[0-9]+\s*)+$/;

    const numberRegexValid = numberRegex.test(this.searchQuery);

    if (this.numberOnly && !numberRegexValid && this.searchQuery !== '') {
      this.error = true;
    } else if (this.numberOnly && this.searchQuery !== '') {
      const wordlen = this.searchQuery.match(/\w+/g).length;
      if (wordlen > 1) {
        this.error = true;
      }
    } else if (this.numberOnly && this.maxValue) {
      const num = Number(this.searchQuery);
      if (this.maxValue < num) {
        this.error = true;
      }
    }
  }

}
